// hooks
import React, { useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { useMutation, useQuery } from "react-query";

// conponents
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { InputTextarea } from "primereact/inputtextarea";
import ReactImageUploading from "react-images-uploading";

// utils
import classNames from "classnames";

// api related
import Api from "../../api/Api";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { TabPanel, TabView } from "primereact/tabview";
import { Image } from "primereact/image";

const ImageOptionTemplate = (option) => {
  return (
    <div className="flex align-items-center">
      <Image width="50" src={option?.images[0]?.url} />
      <div className="pl-4">{option.title}</div>
    </div>
  );
};

function FieldArray({ control, index, currentValue, imagesOption, loadingImageOption, remove }) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section style={{ borderRadius: 0 }} className="w-full card">
      <TabView
        className="content-tabs "
        activeIndex={activeIndex}
        onTabChange={(e) => {
          console.log(e);
          setActiveIndex(e.index);
        }}
      >
        <TabPanel header="Content Details">
          <div className="grid">
            <div className="field col-12 ">
              <label htmlFor={`maps_pin.${index}.image`}>Image : </label>
              <Controller
                control={control}
                defaultValue={null}
                name={`maps_pin.${index}.image`}
                render={({ field }) => (
                  <Dropdown optionLabel="title" optionValue="_id" filter showClear className="w-full" onBlur={field.onBlur} id="status" inputRef={field.ref} value={field.value} onChange={(e) => field.onChange(e)} options={imagesOption} itemTemplate={ImageOptionTemplate} placeholder="Select image" />
                )}
              />
            </div>
            <div className="field col-12">
              <label htmlFor={`maps_pin.${index}.title`}>Title : </label>
              <div className="w-full">
                <Controller control={control} defaultValue={""} name={`maps_pin.${index}.title`} render={({ field }) => <InputText placeholder="Input title" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className="w-full" />} />
              </div>
            </div>
            <div className="field col-12">
              <label htmlFor={`maps_pin.${index}.small_text`}>Text : </label>
              <div className="w-full">
                <Controller
                  rules={{ required: true }}
                  control={control}
                  name={`maps_pin.${index}.small_text`}
                  defaultValue={""}
                  render={({ field }) => <InputTextarea value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} className={classNames("w-full")} placeholder="input text" autoResize rows="4" cols="20" />}
                />
              </div>
            </div>
            <div className="field col-12">
              <label htmlFor={`maps_pin.${index}.top`}>Top : </label>
              <div className="w-full">
                <Controller control={control} defaultValue={""} name={`maps_pin.${index}.top`} render={({ field }) => <InputText placeholder="Input top" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className="w-full" />} />
              </div>
            </div>
            <div className="field col-12">
              <label htmlFor={`maps_pin.${index}.left`}>Left : </label>
              <div className="w-full">
                <Controller control={control} defaultValue={""} name={`maps_pin.${index}.left`} render={({ field }) => <InputText placeholder="Input left" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className="w-full" />} />
              </div>
            </div>
          </div>
        </TabPanel>

        <TabPanel header="Remove" headerTemplate={<Button className="p-button p-component p-button-text p-button-danger" label="Remove Content" icon="pi pi-times block " onClick={() => remove(index)} />}></TabPanel>
      </TabView>
    </section>
  );
}

const DestinationPage = () => {
  let type = 1;
  const [id, setId] = useState("");
  const [images, setImages] = useState([]);

  // hooks
  const { control, handleSubmit, formState, reset } = useForm();
  const { fields, append, remove } = useFieldArray({ name: "maps_pin", control: control });

  const { data: imagesOption, isLoading: loadingImageOption } = useQuery(["content-image", type], () => getImageOptions());
  const { isLoading: createLoading, mutate: crateMutate } = useMutation(async (data) => await Api().post("/destination/edit", data), {
    onSettled: async (response, error) => {
      try {
        if (response.data.status !== 200) {
          throw new Error(response.data.message);
        }
        toast.success("Success updated!");
        getDetails();
      } catch (error) {
        toast.error(error.message || "Something went wrong , try again later", { duration: 5000 });
      }
    },
  });

  // functions
  const getImageOptions = async () => {
    try {
      const res = await Api().get(`/content-image?type=${type}&limit=100`);

      if (res.data.status !== 200) {
        throw new Error(res.data.message);
      }

      return res.data.data;
    } catch (error) {
      toast.error(error.message);
      return error;
    }
  };

  const onChangeImages = (imageList) => {
    setImages(imageList);
  };

  const onSubmit = (data) => {
    const formData = new FormData();
    let file_key = ["files_thumbnail", "files_mobile", "files"];
    // if data is array then its gonna looop

    let array_key = ["no"];

    data.id = id;
    data.banner = JSON.stringify(data.banner || []);
    data.destinations = JSON.stringify(data.destinations || []);
    data.vessels = JSON.stringify(data.vessels || []);
    data.journals = JSON.stringify(data.journals || []);
    data.maps_pin = JSON.stringify(data.maps_pin || []);
    data.section2_images_mobile = [];

    // image section 5
    if (images.length) {
      // prev images
      let temp_prev_images = [];
      // new images
      let temp_image = [];
      for (let i = 0; i < images.length; i++) {
        // this mean its a prev image
        if (images[i].data_url.includes("https")) {
          temp_prev_images.push(images[i].file);
        } else {
          temp_image.push(images[i].file);
        }
      }
      if (temp_prev_images.length) {
        data.section2_images = JSON.stringify(temp_prev_images);
      } else {
        data.section2_images = [];
        // delete data.section2_images;
      }
      if (temp_image.length) {
        data.files = temp_image;
      }
    }

    for (const key in data) {
      let isFile = file_key.find((data) => data === key);
      let isArrayKey = array_key.find((data) => data === key);
      if (isFile && !isArrayKey) {
        formData.append(key, data[key][0]);
      }

      if (!isFile && isArrayKey) {
        for (let i = 0; i < data[isArrayKey].length; i++) {
          formData.append(key, data[isArrayKey][i]);
        }
      }
      if (!isFile && !isArrayKey) {
        formData.append(key, data[key]);
      }
    }

    crateMutate(formData);
  };

  const getDetails = async () => {
    try {
      const res = await Api().get("/destination/detail");

      if (res.data.status !== 200) {
        throw new Error(res.data.message);
      }

      // mapping
      let temp_images_section_2 = [];
      let result = res.data.data;

      if (result.section2_images?.length) {
        for (let i = 0; i < result.section2_images.length; i++) {
          temp_images_section_2.push({ data_url: result.section2_images[i].url, file: result.section2_images[i] });
        }
      }

      setId(result._id);
      setImages(temp_images_section_2);
      reset({ ...result });
      return result;
    } catch (error) {
      toast.error(error.message);
      return error;
    }
  };

  // components
  const leftToolbar = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <h4 className="uppercase" style={{ margin: 0 }}>
            Destination Setting
          </h4>
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    getDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} style={{ borderRadius: "0px" }} className="card grid col-12 mx-auto">
        <div className="col-12">
          <Toolbar className="mb-4 w-full" left={leftToolbar} />
        </div>
        <div className="col-12">
          <p className="font-bold uppercase">Section 1</p>
        </div>
        <div className="field col-12">
          <label htmlFor="section1_title">Title : </label>
          <div className="w-full">
            <Controller
              rules={{ required: true }}
              control={control}
              defaultValue={""}
              name="section1_title"
              render={({ field }) => (
                <InputText
                  placeholder="Input title"
                  value={field.value}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  onChange={(e) => field.onChange(e)}
                  id="name"
                  type="text"
                  className={classNames(
                    {
                      "p-invalid": formState.errors?.section1_title,
                    },
                    "w-full"
                  )}
                />
              )}
            />
            {formState.errors?.section1_title && (
              <small id="name" className="p-error block pt-1">
                field required
              </small>
            )}
          </div>
        </div>
        <div className="field col-12">
          <label htmlFor="section1_description">Description : </label>
          <div className="w-full">
            <Controller
              rules={{ required: true }}
              control={control}
              name="section1_description"
              defaultValue={""}
              render={({ field }) => (
                <InputTextarea
                  value={field.value}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  onChange={(e) => field.onChange(e)}
                  className={classNames(
                    {
                      "p-invalid": formState.errors?.section1_description,
                    },
                    "w-full"
                  )}
                  placeholder="Input description"
                  autoResize
                  rows={4}
                />
              )}
            />
            {formState.errors?.section1_description && (
              <small id="section1_description" className="p-error block pt-1">
                filed required
              </small>
            )}
          </div>
        </div>

        <div className="col-12">
          <p className="font-bold uppercase">Section 2</p>
        </div>
        <div className="field col-12 lg:col-12">
          <label htmlFor="section2_title">Title : </label>
          <div className="w-full">
            <Controller
              rules={{ required: true }}
              control={control}
              defaultValue={""}
              name="section2_title"
              render={({ field }) => (
                <InputText
                  placeholder="Input title"
                  value={field.value}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  onChange={(e) => field.onChange(e)}
                  id="name"
                  type="text"
                  className={classNames(
                    {
                      "p-invalid": formState.errors?.section2_title,
                    },
                    "w-full"
                  )}
                />
              )}
            />
            {formState.errors?.section2_title && (
              <small id="name" className="p-error block pt-1">
                field required
              </small>
            )}
          </div>
        </div>
        {/* <section style={{ borderRadius: 0 }} className="field col-12 ">
          <label htmlFor="">Upload Images: </label>
          <ReactImageUploading style={{ width: "100%" }} value={images} onChange={onChangeImages} maxNumber={6} dataURLKey="data_url" acceptType={["jpg", "png", "jpeg"]}>
            {({ imageList, onImageUpload, onImageUpdate, onImageRemove, dragProps }) => (
              <div style={{ minHeight: "140px" }} className="p-toolbar p-component w-full flex flex-column justify-content-center align-items-center">
                <div className="flex justify-content-center w-full">
                  <Button type="button" onClick={onImageUpload} {...dragProps} label="Click or Drop here" />
                </div>

                {imageList.length ? (
                  <div className="grid mt-4 w-full">
                    {imageList.map((image, index) => (
                      <div key={index} className="col-6 lg:col-2 relative">
                        <img src={image.data_url} alt="" className="w-full" style={{ aspectRatio: "1/1", objectFit: "cover" }} />
                        <Button type="button" className="p-button-danger absolute top-0 right-0" onClick={() => onImageRemove(index)} icon="pi pi-trash" />
                        <div className="flex" style={{ gap: "10px" }}>
                          <Button type="button" className="w-full" onClick={() => onImageUpdate(index)} label="Update" icon="pi pi-pencil" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            )}
          </ReactImageUploading>
        </section> */}
        <div className="col-12">
          <p className="font-bold uppercase">Section 3</p>
        </div>
        <div className="field col-12 lg:col-12">
          <label htmlFor="section3_title">Title : </label>
          <div className="w-full">
            <Controller
              rules={{ required: true }}
              control={control}
              defaultValue={""}
              name="section3_title"
              render={({ field }) => (
                <InputText
                  placeholder="Input title"
                  value={field.value}
                  onBlur={field.onBlur}
                  ref={field.ref}
                  onChange={(e) => field.onChange(e)}
                  id="name"
                  type="text"
                  className={classNames(
                    {
                      "p-invalid": formState.errors?.section3_title,
                    },
                    "w-full"
                  )}
                />
              )}
            />
            {formState.errors?.section3_title && (
              <small id="name" className="p-error block pt-1">
                field required
              </small>
            )}
          </div>
        </div>
        <div className="field col-12 lg:col-12">
          <label htmlFor="section3_button_route">Button Route : </label>
          <div className="w-full">
            <Controller
              rules={{ required: true }}
              control={control}
              defaultValue={""}
              name="section3_button_route"
              render={({ field }) => <InputText placeholder="Input route" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className={classNames("w-full")} />}
            />
          </div>
        </div>
        {/* <div className="col-12">
          <label htmlFor="images">Maps Pin : </label>
        </div>
        <section className="col-12 " style={{ borderRadius: 0 }}>
          {fields.map((item, index) => (
            <FieldArray key={item.id} currentValue={item} control={control} index={index} imagesOption={imagesOption} loadingImageOption={loadingImageOption} remove={remove} />
          ))}
        </section> */}
        {/* <div className="col-12  mb-4 ">
          <Button type="button" onClick={() => append({})} label="Add more map pin" className=" p-button-primary" />
        </div> */}
        <div className="flex justify-content-center mt-4 w-full">
          <Button label="Save" loading={createLoading} className=" p-button-primary mr-4" />
          <Link to="/dashboard">
            <Button type="button" label="Back" className=" p-button-secondary" />
          </Link>
        </div>
      </form>
    </>
  );
};

const comparisonFn = function (prevProps, nextProps) {
  return prevProps.location?.path === nextProps.location?.path;
};

export default React.memo(DestinationPage, comparisonFn);
